<template>
    <div>404 Page not found</div>
</template>

<script>
export default {
    created() {
        // Redirect outside the app using plain old javascript
        window.location.href = '/404.html';
    },
};
</script>
